import { API_CALL_ERROR, BEGIN_API_CALL } from './api-status-action';

interface ApiCallAction {
    type: 'API_CALL_ERROR' | 'BEGIN_API_CALL';
    payload: Error;
}

const actionTypeEndsInSuccess = (type: string) => {
    return type.substring(type.length - 8) === '_SUCCESS';
};

const actionTypeIsBegin = (type: string) => {
    return type.startsWith(BEGIN_API_CALL);
};

const actionTypeIsError = (type: string) => {
    return (
        type.startsWith(API_CALL_ERROR) ||
        type.substring(type.length - 6) === '_ERROR'
    );
};

export const apiStatusReducer = (state = 0, action: ApiCallAction) => {
    if (actionTypeIsBegin(action.type)) {
        return state + 1;
    } else if (
        actionTypeIsError(action.type) ||
        actionTypeEndsInSuccess(action.type)
    ) {
        return state > 0 ? state - 1 : state;
    }

    return state;
};

export const apiErrorReducer = (state = '', action: ApiCallAction) => {
    if (actionTypeIsBegin(action.type)) {
        return '';
    }

    if (actionTypeIsError(action.type)) {
        return action.payload
            ? action.payload.message
            : action.type + ' unspecified error';
    }

    return state;
};
